
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franquicias",
      function () {
        return require("private-next-pages/franquicias/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franquicias"])
      });
    }
  